import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDSIUACsR0I7rMgX2e7_yf2KhHtrsqUPO4",
  authDomain: "we-chat-991f0.firebaseapp.com",
  projectId: "we-chat-991f0",
  storageBucket: "we-chat-991f0.appspot.com",
  messagingSenderId: "108129626142",
  appId: "1:108129626142:web:94235663805156f458260f",
  measurementId: "G-2JL8ZHJBQE",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, db };
